import { IconProps } from '@euler/app/components/icons/types';
import { useSvgProps } from '@euler/app/components/icons/util';
import { FC, memo } from 'react';
import { Path, Svg } from 'react-native-svg';

export const WaitingIcon: FC<IconProps> = memo(props => {
  const { fill = '#000', ...svgProps } = useSvgProps(props, 50, 50);
  return (
    <Svg viewBox="0 0 1228 1024" fill="none" {...svgProps}>
      <Path
        d="M554.656 170.656h-85.344v362.656l273.056 183.456 51.2-68.256-238.944-157.856z"
        fill={fill}
      />
      <Path
        d="M512 0C230.4 0 0 230.4 0 512s230.4 512 512 512 512-230.4 512-512S793.6 0 512 0z m0 938.656c-234.656 0-426.656-192-426.656-426.656S277.344 85.344 512 85.344s426.656 192 426.656 426.656-192 426.656-426.656 426.656z"
        fill={fill}
      />
    </Svg>
  );
});
